<template>
  <article v-on:click="$emit('perform', 'openContent', content)">
    <div class="wrapper">
      <img class="avatar" :src="callAvaUrl(eventAvatar)" />
      <div v-if="totalTickets > 0" class="tickets">
        {{ totalTickets }} Tickets
      </div>
      <div v-if="content && content.attributes && content.attributes['converted-start']" class="calendar-circle">
        <div class="month">
          {{ formatEventMonth(content.attributes) }}
        </div>
        <div class="day" v-if="content && content.attributes">{{ formatEventDay(content.attributes) }}</div>
      </div>
      <div class="title" v-if="content && content.attributes"><b>{{ content.attributes.title }}</b>
        <span v-if="content?.attributes.status == 0" class="status-badge draft">Draft</span>
      </div>
      <div class="full-date" v-if="content && content.attributes">{{ formatEventStartDateTime(content.attributes) }}</div>
      <div v-if="addressLine1" class="full-date">{{ addressLine1 }}</div>
      <div v-if="city" class="full-date">{{ city }}, {{ state }} {{ zip }}</div>
    </div>
  </article>
</template>

<script>
import moment from "moment-timezone";
import { mapState, mapActions, mapGetters } from "vuex";
import {
  formatCurrency,
  findOrganizerParticipation,
  avaUrl,
  formatDateTimeTimezoneConversion,formatDateTimeNoTimezoneConversion,
  formatEventLine1, railsTzToMomentTz,  formatEventLine2, eventDay, eventMonth
} from "../../../common";
import { userInfo } from "../../../common/user-info";
import ContentPayableMixin from "../../ContentPayableMixin";
import AddressMixin from "../../AddressMixin";
import {eventBus} from "@/main";
import ContentMixin from "@/components/ContentMixin.vue";
export default {
  mixins: [ContentPayableMixin, AddressMixin],
  name: "PayableEventListed",
  props: ["id", "channel", "rally", "content"],
  data() {
    return {
      locationLoaded: false
    }
  },
  async created() {
    if(this.content && this.content.attributes) {
      await this.fetchAddressesByIds({addressIds: [this.content.attributes['address-id']]})
      this.locationLoaded = true
    }
  },
  computed: {
    ...mapState("contents", ["contentById"]),
    ...mapState("locations", ["locationsByAddressId"]),
    eventAvatar() {
      if(this.content && this.content.relationships && this.content.relationships.avatar) {
        return this.contentById[this.content.relationships.avatar.data.id];
      } else {
        return ''
      }
    },
    totalTickets() {
      let ticketCount = 0
      if(this.content && this.content.attributes) {
        if(this.content.attributes['child-content-participants'] && this.content.attributes['child-content-participants'][0]) {
          this.content.attributes['child-content-participants'].forEach(participant => {
            ticketCount = ticketCount + participant.quantity
          })
        }
      }
      return ticketCount
    },
  },
  methods: {
    ...mapActions("contents", ["fetchContents"]),
    ...mapActions("locations", ["fetchAddressesByIds"]),
    formatEventMonth(eventDate) {
      return eventMonth(eventDate,  railsTzToMomentTz(userInfo().timezone))
    },
    formatEventDay(eventDate) {
      return eventDay(eventDate ,  railsTzToMomentTz(userInfo().timezone))
    },
    formatEventStartDateTime(eventDate) {
      return formatDateTimeTimezoneConversion(eventDate, railsTzToMomentTz(userInfo().timezone))
    } ,
    doFormatEventLine1(d) {
      return formatEventLine1(d, railsTzToMomentTz(userInfo().timezone))
    },
  }
};
</script>
